import { RenewalPet } from './renewal-pet';
import { RenewalOtherOccupant } from './renewal-other-occupant';
import { RenewalResident } from './renewal-resident';
import { PropertyViewCard } from './property-view-card';

export class RenewalOtherOccupantForm {
    constructor(
        public LeaseRenewalToken: string = '',
        public AccessToken: string = '',
        public ResidentKey: number = null,
        public LeaseRenewalKey: number = null,
        public Residents: RenewalResident[] = [],
        public Pets: RenewalPet[] = [],
        public OtherOccupants: RenewalOtherOccupant[] = [],
        public HasPets: boolean = null,
        public HasOtherOccupants: boolean = null,
        public IsLocked: boolean = true,

    ) { }
}
